/* jt-bestellen-fix-v3 */
(function () {
  var path = (window.location && window.location.pathname) || '';
  if (!/bestellen-betalen-service/i.test(path)) return;
  var SRC = "https://jt-products.eu/cdn/shop/files/Hulp_nodig_bij_je_bestelling_webp.webp?v=1779373439&width=800";
  var ALT = {
    de: 'Hilfe bei Ihrer Bestellung',
    fr: "Besoin d'aide pour votre commande",
    en: 'Need help with your order',
    it: 'Hai bisogno di aiuto con il tuo ordine',
    es: 'Necesitas ayuda con tu pedido',
    pl: 'Potrzebujesz pomocy przy skladaniu zamowienia?',
    pt: 'Precisa de ajuda com a sua encomenda?',
    nl: 'Hulp nodig bij je bestelling'
  };
  function code() {
    var l = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'nl')
      .toLowerCase()
      .split('-')[0];
    return ALT[l] ? l : 'nl';
  }
  function fix() {
    document.querySelectorAll('.image-with-text__image-container').forEach(function (box) {
      var ph = box.querySelector('svg.placeholder-svg');
      var img = box.querySelector('img');
      var src = img && img.getAttribute('src');
      if (src && /Hulp_nodig_bij_je_bestelling_webp/i.test(src)) return;
      if (src && !/placeholder/i.test(src) && !ph) return;
      var el = document.createElement('img');
      el.src = SRC;
      el.alt = ALT[code()] || ALT.nl;
      el.loading = 'lazy';
      el.setAttribute('width', '800');
      if (ph) ph.replaceWith(el);
      else if (img) {
        img.src = SRC;
        img.alt = ALT[code()] || ALT.nl;
      } else {
        box.appendChild(el);
      }
    });
  }
  function boot() {
    fix();
    [50, 200, 600, 1500, 3000, 6000].forEach(function (ms) {
      setTimeout(fix, ms);
    });
    if (window.MutationObserver) {
      var mo = new MutationObserver(fix);
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () {
        try {
          mo.disconnect();
        } catch (e) {}
      }, 15000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
/* jt-bestellen-fix-v3-bust:1785236668161 */

/* jt-freeze-fix-v3 1785685677195 */
